import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { PublicRetailer } from '@src/app/model/public-retailer';

@Component({
  selector: 'app-scope-selection',
  templateUrl: './scope-selection.component.html',
  styleUrls: ['./scope-selection.component.scss'],
  standalone: false,
})
export class ScopeSelectionComponent implements OnChanges {
  @Input() public scopes: PublicRetailer[];

  public form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = fb.group({
      scopes: new FormArray([]),
    });
  }

  get scopeFormArray() {
    return this.form.controls.scopes as FormArray;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.scopes) {
      const scopes: string[] = changes.scopes.currentValue;
      scopes.forEach((x, i) => {
        (this.form.controls.scopes as FormArray).push(this.fb.control(true));
      });
    }
  }

  public selectedScopes(): PublicRetailer[] {
    return this.scopeFormArray.controls.map((x, i) => x.value ? this.scopes[i] : null).filter(x => x !== null);
  }

  public setAll(check: boolean): void {
    (this.form.controls.scopes as FormArray).controls.forEach(ctrl => ctrl.setValue(check));
  }
}
